import { IconProps } from "./Icons";

export const IconDownload = ({ width = 22, height = 23 }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 22 23"
    fill="none"
  >
    <g clipPath="url(#clip0_5700_97)">
      <path
        d="M10.9995 12.8204V3.2749"
        stroke="white"
        strokeWidth="1.36364"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4995 12.8203V18.2749H3.49951V12.8203"
        stroke="white"
        strokeWidth="1.36364"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.409 9.41113L10.9999 12.8202L7.59082 9.41113"
        stroke="white"
        strokeWidth="1.36364"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5700_97">
        <rect
          width="21.8182"
          height="21.8182"
          fill="white"
          transform="translate(0.0908203 0.547852)"
        />
      </clipPath>
    </defs>
  </svg>
);
